<template>
<div>
    <div class='card' v-loading="loading">
        <div class='card-header'>
            <el-row type="flex" justify="center">
            <el-col :span="12">
                <label class='az-content-label' style='text-transform: none'>Minimum Pension Status
                </label>
            </el-col>
            <el-col :span="8">
                <el-input 
                    style="float:right"
                    size='mini'
                    v-model="message" 
                    prefix-icon="el-icon-search"
                    placeholder="Search">
                </el-input>
            </el-col>
            <el-col :span="4" >
                <span style="float:right">
                  <el-button size="mini" v-on:click="other.exportExcel('Minimum Pensions Status.xlsx')">Excel</el-button>
                  <el-button size="mini" v-on:click="generateReport">PDF</el-button>
                </span>
            </el-col>
            </el-row>
            <p class="tx-12">Current Financial Year Drawdowns {{dateformats.getFinancialYear()}}</p>
        </div>
        <div class='card-body tx-13' >
           <el-table
                :data="tableData_1.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                stripe
                size="small"
                style="width: 100%;font-size:10px"
                :default-sort = "{prop: 'trustee__smsf__fund_name', order: 'ascending'}"
                >
                <el-table-column
                type="expand"
                >
                <template slot-scope="props">
                    <el-table
                        :data="props.row.pensions"
                        size="mini"
                        border
                        style="width: 100%;font-size:11px"
                    >
                        <el-table-column
                        prop="account_name"
                        label="Pension Name"
                        >
                        <template slot-scope="detail">
                          {{isSample?'Sample Pension '+(detail.$index+1):detail.row.account_name}}
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="year_to_date"
                        label="Drawndowns to Date"
                        >
                        <template slot-scope="detail">
                          {{currentformats.AUformat(detail.row.year_to_date)}}
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="required_for_minimum"
                        label="Required to Reach Minimum"
                        >
                        <template slot-scope="detail">
                          {{currentformats.AUformat(detail.row.required_for_minimum)}}
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="minimum"
                        label="Minimum"
                        >
                        <template slot-scope="detail">
                          {{currentformats.AUformat(detail.row.minimum)}}
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="maximum"
                        label="Maximum"
                        >
                        <template slot-scope="detail">
                          {{currentformats.AUformat(detail.row.maximum)}}
                        </template>
                        </el-table-column>
                    </el-table>
                </template>
                </el-table-column>
                <el-table-column
                prop="trustee__smsf__fund_name,trustee__smsf__fund_code"
                label="Fund Name"
                sortable
                style='font-weight:500'
                >
                <template slot-scope="scope" >
                    <div style='font-weight:500'>
                    <router-link :to="{path:'/funddashboard/'+scope.row['trustee__smsf__fund_code'],query:{name:scope.row['trustee__smsf__fund_name']}}">{{isSample?'Sample Family Super Fund '+(scope.$index+1):scope.row['trustee__smsf__fund_name']}} </router-link>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                prop="trustee__trustee_name"
                label="Member"
                sortable
                >
                <template slot-scope="scope">
                  {{isSample?'Mr Mike Sample '+(scope.$index+1):scope.row.trustee__trustee_name}}
                </template>
                </el-table-column>
                <el-table-column
                prop="year_to_date"
                label="Drawndowns to Date"
                sortable
                >
                <template slot-scope="scope" >
                  {{currentformats.AUformat(scope.row.year_to_date)}}
                </template>
                </el-table-column>
                <el-table-column
                prop="required_for_minimum"
                label="Required to Reach Minimum"
                sortable
                >
                <template slot-scope="scope" >
                  {{currentformats.AUformat(scope.row.required_for_minimum)}}
                </template>
                </el-table-column>
                <el-table-column
                prop="minimum"
                label="Minimum"
                sortable
                >
                <template slot-scope="scope" >
                  {{currentformats.AUformat(scope.row.minimum)}}
                </template>
                </el-table-column>
                <el-table-column
                prop="maximum"
                label="Maximum"
                sortable
                >
                <template slot-scope="scope" >
                  {{currentformats.AUformat(scope.row.maximum)}}
                </template>
                </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 60px;">
            <el-pagination
                :current-page="currentPage"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="total"
                @current-change="current_change">
            </el-pagination>
            </div>
           <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="Cash at Bank"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="90%"
    
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
        >
        <section slot="pdf-content">
            <table id="table" class="table">
              <thead>
                <tr>
                  <th>Fund Name</th>
                  <th>Member</th>
                  <th>Drawndowns to Date</th>
                  <th>Required to reach Minimum</th>
                  <th>Minimum</th>
                  <th>Maximum</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(pension,index) in pension_list">
                  <tr :key="'summary-'+index" v-if=true>
                    <td style='font-weight:500'><router-link :to="{path:'/funddashboard/'+pension.trustee__smsf__fund_code,query:{name:pension.trustee__smsf__fund_name}}">{{isSample?'Sample Family Super Fund '+(index+1):pension.trustee__smsf__fund_name}} </router-link></td>
                    <td>{{isSample?'Mr Mike Sample '+(index+1):pension.trustee__trustee_name}}</td>
                    <td>{{currentformats.AUformat(pension.year_to_date)}}</td>
                    <td>{{currentformats.AUformat(pension.required_for_minimum)}}</td>
                    <td>{{currentformats.AUformat(pension.minimum)}}</td>
                    <td>{{currentformats.AUformat(pension.maximum)}}</td>
                  </tr>
                  <tr :key="'details-'+index" v-if="(pension.pensions || []).length">
                    <td colspan="6">
                      <table class="table" style="width:100%; font-size:11px;">
                        <thead>
                          <tr>
                            <th>Pension Name</th>
                            <th>Drawndowns to Date</th>
                            <th>Required to reach Minimum</th>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(detail,detailIndex) in pension.pensions" :key="detailIndex">
                            <td>{{isSample?'Sample Pension '+(detailIndex+1):detail.account_name}}</td>
                            <td>{{currentformats.AUformat(detail.year_to_date)}}</td>
                            <td>{{currentformats.AUformat(detail.required_for_minimum)}}</td>
                            <td>{{currentformats.AUformat(detail.minimum)}}</td>
                            <td>{{currentformats.AUformat(detail.maximum)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
        </section>
        </vue-html2pdf>
        <DisclaimerV2>
          <div style="font-size:12px;max-width:600px">
            The minimum pension amounts displayed are estimates if the most recent 30 June tax return has not been lodged. Final figures should be verified once year-end accounts are finalised.
          </div>
        </DisclaimerV2>
        </div>
    </div>
     <div class='card mg-t-20' v-loading="loading">
        <div class='card-header'>
            <el-row>
                <el-col :span="16">
                    <label class='az-content-label' style='text-transform: none'>Members who have not commenced pensions but met the preservation age</label>
                </el-col>
                <el-col :span="4">
                    <el-input 
                    style='margin-bottom:5px'
                    size='mini'
                    v-model="message_2" 
                    prefix-icon="el-icon-search"
                    placeholder="Search">
                    </el-input>
                </el-col>
                <el-col :span="4" >
                    <span style="float:right">
                      <el-button size="mini" v-on:click="exportExcel('Members who have not commenced pensions but met the preservation age.xlsx')">Excel</el-button>
                      <el-button size="mini" v-on:click="generateReport_2">PDF</el-button>
                    </span>
                </el-col>
            </el-row>
            <p class="tx-12">{{dateformats.getFinancialYear()}}</p>
        </div>
        <div class='card-body tx-13' >
          <el-table
                :data="tableData_2.slice((currentPage_2-1)*pagesize_2,currentPage_2*pagesize_2)"
                stripe
                size="small"
                style="width: 100%;font-size:13px"
                :default-sort = "{prop: 'smsf__fund_name', order: 'ascending'}"
                >
                <el-table-column
                prop="smsf__fund_name,smsf__fund_code"
                label="Fund Name"
                sortable
                style='font-weight:500'
                >
                <template slot-scope="scope" >
                    <div style='font-weight:500'>
                    <router-link :to="{path:'/funddashboard/'+scope.row['smsf__fund_code'],query:{name:scope.row['smsf__fund_name']}}">{{isSample?'Sample Family Super Fund '+(index+1):scope.row['smsf__fund_name']}} </router-link>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                prop="trustee_name"
                label="Member"
                sortable
                >
                </el-table-column>
                <el-table-column
                prop="age"
                label="Age"
                sortable
                >
                </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 60px;">
            <el-pagination
                :current-page="currentPage_2"
                :page-size="pagesize_2"
                layout="total, prev, pager, next, jumper"
                :total="total_2"
                @current-change="current_change_2">
            </el-pagination>
            </div>
        </div>
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="Cash at Bank"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="90%"
    
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf_2"
        >
        <section slot="pdf-content">
            <table id="table" class="table">
              <thead>
                <tr>
                  <th>Fund Name</th>
                  <th>Member</th>
                  <th>Drawndowns to Date</th>
                  <th>Required to reach Minimum</th>
                  <th>Minimum</th>
                  <th>Maximum</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(pension,index) in pension_list">
                  <tr :key="'summary-'+index"  v-if=true>
                    <td style='font-weight:500'><router-link :to="{path:'/funddashboard/'+pension.trustee__smsf__fund_code,query:{name:pension.trustee__smsf__fund_name}}">{{isSample?'Sample Family Super Fund '+(index+1):pension.trustee__smsf__fund_name}} </router-link></td>
                    <td>{{isSample?'Mr Mike Sample '+(index+1):pension.trustee__trustee_name}}</td>
                    <td>{{currentformats.AUformat(pension.year_to_date)}}</td>
                    <td>{{currentformats.AUformat(pension.required_for_minimum)}}</td>
                    <td>{{currentformats.AUformat(pension.minimum)}}</td>
                    <td>{{currentformats.AUformat(pension.maximum)}}</td>
                  </tr>
                  <tr :key="'details-'+index" v-if="(pension.pensions || []).length">
                    <td colspan="6">
                      <table class="table" style="width:100%; font-size:11px;">
                        <thead>
                          <tr>
                            <th>Pension Name</th>
                            <th>Drawndowns to Date</th>
                            <th>Required to reach Minimum</th>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(detail,detailIndex) in pension.pensions" :key="detailIndex">
                            <td>{{isSample?'Sample Pension '+(detailIndex+1):detail.account_name}}</td>
                            <td>{{currentformats.AUformat(detail.year_to_date)}}</td>
                            <td>{{currentformats.AUformat(detail.required_for_minimum)}}</td>
                            <td>{{currentformats.AUformat(detail.minimum)}}</td>
                            <td>{{currentformats.AUformat(detail.maximum)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
        </section>
        </vue-html2pdf>
    </div>
</div>
</template>
<script>
import currentformats from '../../../utils/currentformats'
import dateformats from '../../../utils/dateformats'
import VueHtml2pdf from 'vue-html2pdf'
import other from '../../../utils/other'
import XLSX from 'xlsx'
export default {
    name:'minpensions',
    components: { 
      VueHtml2pdf,
      DisclaimerV2: () => import('@/views/adviserpanel/elements/DisclaimerV2.vue'),
    },
    data(){
        return{
            isSample:false,
            currentformats:currentformats,
            dateformats:dateformats,
            message:'',
            message_2:'',
            pension_list:[],
            pension_list_raw:[],
            no_pension_list:[],
            loading:true,
            total: 0,
            pagesize:5,
            currentPage:1,
            total_2: 0,
            pagesize_2:5,
            currentPage_2:1,
            other:other,
        }
    },
    computed:{
      tableData_1:function(){
        const message = this.message && this.message.toLowerCase();
        if(!message){
          return this.pension_list;
        }
        return this.pension_list.filter(group => {
          const groupValues = [
            group.trustee__smsf__fund_name,
            group.trustee__trustee_name,
            group.year_to_date,
            group.required_for_minimum,
            group.minimum,
            group.maximum,
          ];
          const groupMatch = groupValues.some(value => {
            return value !== undefined && value !== null && String(value).toLowerCase().indexOf(message) > -1;
          });
          if (groupMatch) {
            return true;
          }
          return (group.pensions || []).some(pension => {
            return [
              pension.account_name,
              pension.year_to_date,
              pension.required_for_minimum,
              pension.minimum,
              pension.maximum,
            ].some(value => value !== undefined && value !== null && String(value).toLowerCase().indexOf(message) > -1);
          });
        });
      },
      tableData_2:function(){
        var message_2=this.message_2;
        if(message_2){
          return  this.no_pension_list.filter(function(dataNews){
            return Object.keys(dataNews).some(function(key){
              return String(dataNews[key]).toLowerCase().indexOf(message_2) > -1
            })
          })
        }
        return this.no_pension_list
      },
    },
    created(){
        this.getPensionsData();
    },
    methods:{
        getPensionsData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample=userdetail['sample'];
            let brand = localStorage.getItem('brand_code')
            
            this.$api.adviserdashboard_api.pensions(brand).then(response =>{
                this.pension_list_raw = response.data['pension_list']
                this.pension_list = this.aggregatePensionData(this.pension_list_raw)
                this.no_pension_list = response.data['no_pension_list']
                this.total = this.pension_list.length
                this.total_2 = this.no_pension_list.length
                this.loading=false;
            });
        
        },
        current_change:function(currentPage){
            this.currentPage = currentPage;
        },
        current_change_2:function(currentPage_2){
            this.currentPage_2 = currentPage_2;
        },
        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
        generateReport_2 () {
            this.$refs.html2Pdf_2.generatePdf()
        },
        aggregatePensionData(pensions){
            if(!Array.isArray(pensions)){
                return [];
            }
            const grouped = {};
            pensions.forEach(item => {
                const key = `${item.trustee__smsf__fund_code || ''}||${item.trustee__trustee_name || ''}`;
                if(!grouped[key]){
                    grouped[key] = {
                        trustee__smsf__fund_name: item.trustee__smsf__fund_name,
                        trustee__smsf__fund_code: item.trustee__smsf__fund_code,
                        trustee__trustee_name: item.trustee__trustee_name,
                        year_to_date: 0,
                        required_for_minimum: 0,
                        minimum: 0,
                        maximum: 0,
                        pensions: [],
                    };
                }
                const year_to_date = Number(item.year_to_date) || 0;
                const required_for_minimum = Number(item.required_for_minimum) || 0;
                const minimum = Number(item.minimum) || 0;
                const maximum = Number(item.maximum) || 0;
                const group = grouped[key];
                group.year_to_date += year_to_date;
                group.required_for_minimum += required_for_minimum;
                group.minimum += minimum;
                group.maximum += maximum;
                group.pensions.push({
                    account_name: item.account_name,
                    year_to_date,
                    required_for_minimum,
                    minimum,
                    maximum,
                });
            });
            return Object.values(grouped);
        },
        exportExcel(excelName) {
            var workbook = XLSX.utils.book_new();
            var ws1 = XLSX.utils.table_to_sheet(document.getElementById('table_2'));
            XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
            XLSX.writeFile(workbook, excelName);

        },
    }
}
</script>
<style scoped>
.tableFixHead          { overflow: auto; height: 500px; }
.tableFixHead thead th { position: sticky; top: 0; z-index: 1; background-color: white;}
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #cdd4e0;
}
</style>

